import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OnlineApplyService } from '@app/admin/service/online.apply.service';
import { ToastrService } from 'ngx-toastr';
import { FileUploader, FileItem, FileLikeObject } from 'ng2-file-upload';
import { config } from '@app/service/config.service';

const URL = config.apiFileUploadUrl;

@Component({
  selector: 'app-report-check-modal',
  templateUrl: './report-check-modal.component.html',
  styleUrls: ['./report-check-modal.component.scss']
})
export class ReportCheckModalComponent implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/  
  public tabIndex = 1;
  public isSubmitting: boolean = false;

  initialValue = ''
  applyInfo = {
    company: this.initialValue,
    depart: this.initialValue,
    name: this.initialValue,
    hp: this.initialValue,
    email_id: this.initialValue,
    email_domain: this.initialValue,
    file_path: this.initialValue,
    file_name: this.initialValue,
  }
  errorMessage = {
    company: '소속',
    depart: '부서',
    name: '성명',
    hp: '연락처',
    email_id: '이메일',
    email_domain: '이메일',
    file_path: '파일',
    file_name: '파일'
  }

  public baseURL = config.baseUrl;
  public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: 'file' });
  public uploadProgress: any = 0;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/  
  constructor(
    public activeModal: NgbActiveModal,
    public onlineApplyService: OnlineApplyService,
    public toastrService: ToastrService,
  ) { }

  /*******************************************************************************
    설  명 : 파일 변경시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  handleUploadFileChanged(event) {
    this.uploader.clearQueue();

    const files: File[] = event.target.files;
    const filteredFiles: File[] = [];
    for (const f of files) {
      filteredFiles.push(f);
    }

    const options = null;
    const filters = null;
    this.uploader.addToQueue(filteredFiles, options, filters);

    this.uploader.uploadAll();
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/  
  ngOnInit(): void {

    // 업로드 허용 파일 설정
    const filetype: string[] = ['pdf'];

    // 업로더 생성
    this.uploader = new FileUploader({
      url: URL,
      itemAlias: 'file',
      maxFileSize: 5 * (1024 * 1024), // 최대 업로드 허용 5MB 용량
      allowedFileType: filetype // 허용 업로드 파일 타입
    });

    // 파일업로드 설정
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      this.uploadProgress = '0%';
    };

    // 업로드시 프로그레스바 처리
    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      this.uploadProgress = progress + '%';
    };

    // 업로드 용량 초과시 처리
    this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
      if ( filter.name == 'fileSize' ) {
        this.toastrService.error( '파일 업로드 용량(50MB)을 초과하였습니다.', '파일 업로드');
      } else if ( filter.name == 'fileType' ) {
        this.toastrService.error( '허용되는 업로드 파일 타입이 아닙니다.', '파일 업로드');
      }
    };

    // 파일업로드 완료시 처리
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      response = $.parseJSON( response );

      if ( response.result ) {
        this.toastrService.success( response.message, '');
        this.applyInfo.file_name = response.origin_filename
        this.applyInfo.file_path = this.baseURL + response.url

      } else {
        this.toastrService.error( response.message, '');
      }
    };
  }

  setEmailDomain($event) {
    this.applyInfo.email_domain = $event.target.value
  }

  submit() {
    if (this.isSubmitting) return;
    for(const key in this.applyInfo) {
      if(!this.applyInfo[key]) {
        this.toastrService.warning(`${this.errorMessage[key]} 을(를) 입력하세요.`)
        return
      }
    }
    this.isSubmitting = true; // 중복 클릭 방지
    const data = {
      ...this.applyInfo,
      email: `${
        this.applyInfo.email_id
      }@${
        this.applyInfo.email_domain
      }`,
    }
    
    this.onlineApplyService.postReportCheck(data)
    .then(res => {
      // 데이터 저장 성공 여부 확인
      if (res && (res.ResultCode === true || res.ResultCode === 'SUCCESS')) {
        // 데이터 저장 성공 시 모달 닫기 (이메일 발송 실패 여부와 관계없이)
        // 이메일 발송 실패는 조용히 처리하고 모달만 닫음
        this.activeModal.close();
      } else {
        // 데이터 저장 실패 시에만 오류 메시지 표시
        this.toastrService.error('신청이 정상적으로 이루어지지 않았습니다.');
        this.isSubmitting = false; // 상태 복원하여 재시도 가능하게
      }
    })
    .catch(err => {
      // catch 블록: 네트워크 오류나 예외 발생 시
      // 서버에서 데이터는 저장했지만 이메일 발송 실패로 오류가 발생한 경우를 고려
      // err 객체에 응답 데이터가 포함되어 있을 수 있음
      const errorResponse = err?.error || err?.response || err;
      
      // 응답에 ResultCode가 있고 true인 경우, 데이터 저장은 성공한 것으로 간주
      if (errorResponse && (errorResponse.ResultCode === true || errorResponse.ResultCode === 'SUCCESS')) {
        // 데이터 저장은 성공했지만 이메일 발송 실패 등의 이유로 catch로 온 경우
        // 모달을 닫고 오류 메시지를 표시하지 않음
        this.activeModal.close();
      } else {
        // 실제 서버 오류 또는 네트워크 오류
        this.toastrService.error('서버 오류가 발생했습니다.');
        this.isSubmitting = false; // 상태 복원하여 재시도 가능하게
      }
    }); 
  }

}
